import { Card, Flex, Label, Loader, Modal } from '@fareye/ui'
import {
  cancelToken,
  get,
  MdBookmark,
  MdBookmarkBorder,
  MdShare,
  MdTextsms,
  post
} from '@fareye/utils'
import { Timezone, PublicHeader, useTranslation } from '@fareye/common'
import React from 'react'
import { TripDetailContext } from '../modules/TripDetails'
import { BreadcrumbItem, HeaderFrame } from '../style/styled'
import Logo from '../utility/fareye-logo.json'
import CopyText from './CopyText'

const initShare = {
  data: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: ''
}

export function Header({
  slug,
  config,
  setIssueClicked,
  showTimezone = false
}: any) {
  const [subscribe, setSubscribe] = React.useState(false)
  const [share, setShare] = React.useState(initShare)
  const [link, setLink] = React.useState<string | null>(null)
  const source = cancelToken().source()
  const { apiResponse } = React.useContext<any>(TripDetailContext)
  const { shareURL, subscribeURL, shareQueryParams, linkURL, issueRaisedConfig, showPublicHeader = true } = config
  const { t } = useTranslation()
  async function fetchMarkData() {
    try {
      const {
        data: { message, success }
      } = await get(`${subscribeURL}${slug}`, source.token)
      setSubscribe(success)
      alert(
        `Success!!, Trip ${
          success ? 'Subscribed' : 'Unsubscribed'
        } Successfully`
      )
    } catch (error) {
      console.error('App Error:', error)
    }
  }

  async function fetchShareSlug() {
    setShare({ ...share, isLoading: true })
    try {
      let payload = {
        ...shareQueryParams,
        resource_id: slug
      }
      const { data } = await post(shareURL, payload, source.token)
      if (data) {
        const link = `${linkURL}/${data.content}`
        setShare({ ...share, isLoading: false })
        setLink(link)
      }
    } catch (error) {
      setShare({ ...share, isLoading: false })
      console.error('App Error:', error)
    }
  }
  const shareIsLoading: boolean = shareURL && share.isLoading //&& !shareExpired
  const showShare: boolean = shareURL //&& !shareExpired

  return (
    <HeaderFrame alignItemsCenter justifyContentSpaceBetween>
      {showShare && (
        <BreadcrumbItem
          variant={`s primary link`}
          disabled
          style={{ background: 'transparent' }}
        >
          {t('Trips')}
        </BreadcrumbItem>
      )}
      {!showShare && showPublicHeader && <PublicHeader />}
      <Flex>
        {showTimezone && <Timezone />}
        {shareIsLoading && <Loader size={24} />}
        {showShare && (
          <Label
            style={{
              cursor: 'pointer',
              marginLeft: '12px',
              color: '#217CE7'
            }}
            onClick={() => fetchShareSlug()}
          >
            <MdShare style={{ marginBottom: '-2px' }} />
            {` ${t('Share')}`}
          </Label>
        )}
        {subscribeURL && false && (
          <Label
            style={{ cursor: 'pointer', marginLeft: '12px', color: '#217CE7' }}
            onClick={() => fetchMarkData()}
          >
            {subscribe ? (
              <MdBookmark style={{ marginBottom: '-2px', color: 'yellow' }} />
            ) : (
              <MdBookmarkBorder style={{ marginBottom: '-2px' }} />
            )}
            {`${subscribe ? 'Unmark' : 'Mark'} Important`}
          </Label>
        )}
        {shareURL && (
          <Label
            style={{ cursor: 'pointer', marginLeft: '12px', color: '#217CE7' }}
            onClick={() => setIssueClicked(true)}
          >
            <MdTextsms style={{ marginBottom: '-2px', marginRight: 5 }} />
            {t(issueRaisedConfig?.config?.issueLabel || 'Issues Raised')} ({apiResponse.data.issuesCount})
          </Label>
        )}
      </Flex>
      {link && (
        <Modal
          variant="xxs"
          toggleModal={Boolean(link)}
          setToggleModal={() => setLink(null)}
        >
          <Card variant="xs" header="Share Trip Link">
            <CopyText link={link} />
          </Card>
        </Modal>
      )}
    </HeaderFrame>
  )
}
